import { Box, SimpleGrid, Text } from "@chakra-ui/layout";
import React from "react";
import NeedHelp from "@modules/Layout/components/NeedHelp";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import InformForm from "./InformForm";

const Contact = () => {
  return (
    <Box my={10}>
      <ResponsiveContainer>
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 4, md: 7, lg: 12, xl: 40 }}
          my={8}
        >
          <Box>
            <Text textStyle="h3" mb={4} color={"blue500"}>
              Report a broken link
            </Text>
            <Text textStyle="hind_r" mb={4}>
              Please, fill out the form below, if you detect any broken links on
              our website. We are committed to addressing broken links promptly
              by repairing or replacing them. Thank you for assisting us in
              keeping our website current and accurate.
            </Text>

            <InformForm />
          </Box>
          <Box ml={{ md: 0, lg: 10, xl: 20 }} mt={{ base: 7, md: 0 }}>
            <NeedHelp />
          </Box>
        </SimpleGrid>
      </ResponsiveContainer>
    </Box>
  );
};

export default Contact;
